<div fxFlex fxLayoutGap="10px" fxLayoutAlign="start center">
  <fs-badge size="25" [image]="account?.image?.small" fxLayout="center"></fs-badge>
  <span> {{ account?.name }} </span>
</div>
